module.exports = __webpack_public_path__ + "static/img/keco-recycle.11d2723.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/keco-recycle.jpg
// module id = GVn7
// module chunks = 0